module.exports = __webpack_public_path__ + "static/media/item2.5e6e2a41.jpg";